/* eslint-disable sonarjs/no-ignored-return */
/* eslint-disable prettier/prettier */
/* eslint-disable sonarjs/cognitive-complexity */
/* eslint-disable security/detect-object-injection */
/* eslint-disable security/detect-non-literal-fs-filename */
import {
  FileModel,
  ISelectItem,
  ModalContainerService,
  NotificationComponent,
} from "@aecom/core";
import { Component, HostListener, OnInit, inject } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import _ from "lodash";
import { Observable } from "rxjs";
import { EmailService, IPRFIItem, IUser } from "src/app/api-generated";
import { ComponentCanDeactivate } from "src/app/guards/pending-changes.guard";
import IRFIViewPrepare from "src/app/models/IRFIViewPrepaer";
import RFIRole from "src/app/models/rfiRoles";
import RFIStatus from "src/app/models/rfiStatus";
import LoadingService from "src/app/services/loading.service";
import LocalContractService from "src/app/services/local-contract.service";
import LocalContractUserService from "src/app/services/local-contractUser.service";
import LocalUserService from "src/app/services/local-user.service";
import RouteParams from "src/app/shared/route-params";
import { isReopened } from "src/app/shared/utils";
import RFICompilingStep from "@models/rfiCompilingStep";
import BaseFunctionService from "@services/baseFunction.service";
import RFIDelegate from "@models/rfiDelegate";
import OptionsScheduleImpact from "@models/OptionsScheduleImpact";
import OptionsCostImpact from "@models/OptionsCostImpact";
import { AuthService, BBJFileListService, BBJSelectUserService } from "@bbj/components";

@Component({
  selector: "app-compiling-rfi",
  templateUrl: "./compiling-rfi.component.html",
  styleUrls: ["./compiling-rfi.component.scss"],
  standalone: false
})
export default class CompilingRfiComponent
  implements OnInit, ComponentCanDeactivate
{
  router = inject(Router);
  private activatedRoute = inject(ActivatedRoute);
  loadingService = inject(LoadingService);
  activemodal = inject(ModalContainerService);
  localContractService = inject(LocalContractService);
  private authService = inject(AuthService);
  private localContractUserService = inject(LocalContractUserService);
  private localUserService = inject(LocalUserService);
  emailService = inject(EmailService);
  bbjFileListService = inject(BBJFileListService);
  baseFunctionService = inject(BaseFunctionService);
  bbjSelectUserService = inject(BBJSelectUserService);

  @HostListener("window:beforeunload")
  canDeactivate(): Observable<boolean> | boolean {
    return !this.hasChanges();
  }

  canIssueRFI = false;

  oldRFI: RFICompilingStep;

  rfi: RFICompilingStep;

  entity: IPRFIItem;

  delegateItem: RFIDelegate;

  users: IUser[];

  contractId: string;

  acknowledge = false;

  defaultTab = "details";

  currentUser: string;

  tempId: string;

  rfiFLowdata:unknown[];

  responseMaxLength = 1500;

  reason: string = '';

  oldReason: string = '';

  public logtab = true;

  ddcManagersList: ISelectItem[] = [];

  delegateList: ISelectItem[] = [];

  srManagerList: ISelectItem[] = [];

  scheduleImpactOptions: ISelectItem[] = [...OptionsScheduleImpact];

  costImpactOptions: ISelectItem[] = [...OptionsCostImpact];

  isCompile = false;

  isPMReview = false;

  isDDCReview = false;

  needDelegate = false;

  ngOnInit(): void {
    this.loadingService.start();
    this.users = this.localUserService.getItems();
    this.currentUser = this.authService.getUserId();
    const data: IRFIViewPrepare = this.activatedRoute.snapshot.data.RFIPrepare;
    this.entity = data.rfi;
    this.isCompile = this.entity.Status === RFIStatus.Review_Period;
    this.isPMReview = this.entity.Status === RFIStatus.PM_Review;
    this.isDDCReview = this.entity.Status === RFIStatus.DDC_Review;
    this.contractId = this.activatedRoute.snapshot.parent.params[RouteParams.ContractId];
    this.baseFunctionService.initUsers();
    this.defaultTab = this.entity.rfi_compiled_response?.filter((cr)=>{return cr.IsDraft === false})?.length > 0
        ? "processing"
        : this.baseFunctionService.reviewersResponse.length > 0 ||  this.baseFunctionService.watchersResponse.length > 0
          ? "responses"
          : "details";

    this.oldRFI = data.compile;

    this.ddcManagersList = this.localContractUserService.getUsersDropDownByRoleIds(false,[RFIRole.DDC_Manager]);
    this.delegateList = this.ddcManagersList.filter((u)=>{return u.id !== this.entity.DDCManagerId});
    this.srManagerList = this.localContractUserService.getUsersDropDownByRoleIds(false, [RFIRole.SR_Manager]);

    this.delegateItem = new RFIDelegate(this.entity);
    if(!this.isCompile && this.oldRFI.DosePMCAccept !== true)
    {
      this.oldReason = this.oldRFI.rfi_compiled_response.Response;
      this.oldRFI.rfi_compiled_response.Response = "";
    }
    this.reason = this.oldReason;
    this.rfi = JSON.parse(JSON.stringify(this.oldRFI));
    this.loadingService.stop();
    if(this.entity.Viewed !== true && isReopened(this.entity))
    {
      this.baseFunctionService.readReopened();
    }
  }

  hasChanges(): boolean {
    if(!this.isCompile && this.rfi.DosePMCAccept !== true)
    {
      return this.oldReason === this.reason;
    }
    const old = JSON.stringify(this.oldRFI);
    const currentRFI = JSON.stringify(this.rfi);

    // true means no changes
    return old !== currentRFI || this.bbjFileListService.areFilesChanged();
  }

  getResponseTitle(): string {
    if(this.isCompile || this.rfi.DosePMCAccept === false)
    {
      return "Compiled Response";
    } else if(this.rfi.ToDDC === false && this.rfi.ToSrManager === false) {
      return "Final Response";
    } else {
      return "Draft Response";
    }
  }

  setAcknowledge(e: boolean): void {
    this.acknowledge = e;
  }

  setResponse(e: string): void {
    this.rfi.rfi_compiled_response.Response = e;
  }

  setScheduleImpact(e: boolean): void {
    this.rfi.rfi_compiled_response.ScheduleImpact = e;
  }

  setCostImpact(e: string): void {
    this.rfi.rfi_compiled_response.CostImpact = e;
  }

  setReason(e: string): void {
    this.reason = e;
  }

  setPMCAccept(e: boolean): void {
    this.rfi.DosePMCAccept = e;
  }

  setSendToDDC(e: boolean): void {
    this.rfi.ToDDC = e;
  }

  setDDCManager(e: ISelectItem): void {
    if (e && !Array.isArray(e)) {
      this.rfi.DDCManagerId = e?.id;
    }
  }

  setNeedDelegate(e: boolean): void {
    this.needDelegate = e;
  }

  setUserSelect(e: ISelectItem): void {
    if (e && !Array.isArray(e)) {
      this.delegateItem.rfi_delegate_detail.UserId = e?.id;
    }
  }

  setSendToSrManager(e: boolean): void {
    this.rfi.ToSrManager = e;
  }

  setSrManager(e: ISelectItem): void {
    if (e && !Array.isArray(e)) {
      this.rfi.SrManagerId = e?.id;
    }
  }

  IsValid(): boolean {
    if(this.needDelegate)
    {
      return this.delegateItem.rfi_delegate_detail.UserId && this.delegateItem.rfi_delegate_detail.UserId!=='';
    } else {
      if(this.isCompile || this.rfi.DosePMCAccept === true) {
        return !(
          !this.rfi.rfi_compiled_response.Response ||
          this.rfi.rfi_compiled_response.Response.trim() === "" || !this.acknowledge
        )
      } else {
        return !(
          !this.reason ||
          this.reason.trim() === ""
        )
      }
    }
    
  }

  IsInputValid(): boolean {
    return this.getReasonLength() <= this.responseMaxLength &&
    this.getResponseLength() <= this.responseMaxLength &&
    !this.baseFunctionService.isInputInvalid(this.reason) &&
    !this.baseFunctionService.isInputInvalid(this.rfi.rfi_compiled_response.Response);
  }

  submitRFI(): void {
    this.canIssueRFI = true;
    // console.log("RFI", this.rfi);

    const validation = this.IsValid() && this.bbjFileListService.isFileNameValid() && this.IsInputValid();
    // console.log(validation);
    if (this.bbjFileListService.hasFilesUploading()) {
      this.bbjFileListService.showFileProgressNotification();
    } else if (validation) {
      const modalInstance = this.activemodal.open(NotificationComponent);
      modalInstance.instance.theme = "light";
      modalInstance.instance.title = "Confirm Action?";
      modalInstance.instance.body = this.needDelegate 
        ? "The BIC tasks will be reassigned to the person you select below (the new BIC). Once the reassignment is complete, the former BIC will no longer have the ability to carry out any tasks related to this RFI." 
        : !this.rfi.DosePMCAccept 
          ? "The RFI compiled response will be send back to the Coordinator."
          :(this.rfi.ToSrManager || this.rfi.ToDDC || this.isCompile)  
            ? "Once submitted, your task will be completed and you will no longer be able to make updates. The RFI will be moved to the next step in the workflow." 
            :'<span class="warningFont">The official response will be sent to the DB and will not be modifiable. Please verify that all information & attachments are correct.</span>';
      modalInstance.result.then((result) => {
        if (result === 1) {
          this.rfi.IsDraft = false;
          this.update();
        }
      });
    }
  }

  saveDraft(): void {
    if (!this.hasChanges()||!this.bbjFileListService.isFileNameValid()||!this.IsInputValid()) return;
  
    if (this.bbjFileListService.hasFilesUploading()) {
      this.bbjFileListService.showFileProgressNotification();
    } else {
      const modalInstance = this.activemodal.open(NotificationComponent);
      modalInstance.instance.theme = "light";
      modalInstance.instance.title = "Save as Draft?";
      modalInstance.instance.body = "Your RFI will save as draft.";
      modalInstance.result.then((result) => {
        if (result === 1) {
          this.rfi.IsDraft = true;
          this.update();
        }
      });
    }
  }

  update(): void {
    this.loadingService.start();
    if(this.needDelegate)
    {
      this.baseFunctionService.delegate(this.delegateItem);
    } else {
      if(!this.isCompile && this.rfi.DosePMCAccept !== true)
      {
        this.rfi.rfi_compiled_response.Response = this.reason;
        this.rfi.rfi_compiled_response.ScheduleImpact = undefined;
        this.rfi.rfi_compiled_response.CostImpact = undefined;
      }
      this.baseFunctionService.update(this.rfi);
    }
  }

  importFile(e: FileModel[]): void {
    this.baseFunctionService.importFile(e);
  }

  deleteFile(e: FileModel): void {
    this.baseFunctionService.deleteFile(e);
  }

  back(): void {
    if (this.hasChanges()) {
      this.baseFunctionService.backAfterConfirm();
    } else {
      this.baseFunctionService.back();
    }
  }

  addFileToAttachment(prevItem: FileModel): void {
    this.baseFunctionService.addFileToAttachment(prevItem);
  }

  addFilesToAttachment(prevItems: FileModel[]): void {
    this.baseFunctionService.addFilesToAttachment(prevItems);
  }

  reassign(): void {
    this.baseFunctionService.reassign();
  }

  getReasonLength(): number {
    return this.reason ? this.reason.length : 0;
  }

  getResponseLength(): number {
    return this.rfi.rfi_compiled_response.Response ? this.rfi.rfi_compiled_response.Response.length : 0;
  }
}
